import $ from 'jquery';
import _ from 'underscore';

/**
 * Manages creation of delivery status column popups
 */
class DeliveryStatusPopupFactory {
  /**
   * Constructs the factory, associating with a grid and rejection view handler
   * @param {Object} grid - The grid to which this factory will be associated
   * @param {Object} handler - Rejection view handler
   */
  constructor({
    grid,
    handler,
  }) {
    this.grid = grid;
    this.handler = handler;
  }
  /**
    * Creates entity object from event target using the grid associated with the factory.
    *
    * @param {Object} event - The backbone click event from where the quality score cell was clicked.
    * @returns {Object} entity - An object which contains Id as property.
  */
  getEventTargetEntity(event) {
    const model = this.getEventTargetModel(event);

    return {
      Id: model.Id,
    };
  }
  /**
    * Gets model object from event target using the grid associated with the factory.
    *
    * @param {Object} event - The backbone click event from where the quality score cell was clicked.
    * @returns {Object} model - Model associated with the entity targeted by the event passed as an argument.
  */
  getEventTargetModel(event) {
    const key = this.grid.gridView.keyOfElement(event.target);

    return this.grid.gridView.itemWithKey(key);
  }
  /**
    * show campaign reject reasons
    * Todo: apjia:update after odata side support return status details, or have new interface that do this
    * Todo: if each entity return same StatusDeliveryDetails, then merge different handlers into one
    *
    * @param {Object} event - The backbone click event from where the quality score cell was clicked.
    * @returns {undefined}.
  */
  showRejectionPopup(event) {
    const entity = this.getEventTargetEntity(event);

    if (!_.isUndefined(this.handler)) {
      $.gridPopup.clickEvent(event,
        this.handler(event, entity),
        'rejectionContainer',
        '',
        true);
    }

    // return popup container to allow view to hide popup
    return $('#rejectionContainer');
  }

  /**
   * close rejection popup handler
   * call this function to close closest rejection container
   * @param {Object} event the backbone click event from where the click from
   * @returns {undefined}
   */
  closeRejectionPopup(event) {
    if (!$(event.target).closest('#rejectionContainer').length) {
      if (document.getElementById('rejectionContainer').style.display !== 'none') {
        $('#rejectionContainer').css('display', 'none');
        $.gridPopup.ResetImage(event);  //eslint-disable-line
      }
    }
  }
}

export { DeliveryStatusPopupFactory };
